import RequestAbstract from "../abstract";

export default class MerchantEmployees extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/merchant-employees";
    }
}
